import theme from '@segment/matcha/foundations/Theme'

import { DominosMonoLogo } from '@segment/matcha/components/CompanyLogos/CompanyMono'

const testimonialData = {
  logo: <DominosMonoLogo color={theme.palette.neutrals.white[100]} />,
  text: `“Having Segment has not only helped us to do the personalization work we’ve always wanted to do, but we can now improve on the effectiveness of our ad campaigns and drive that feedback loop.”`,
  name: `Christian Rocha Castillo`,
  position: `Deputy Director Ecommerce/Digital Media`,
  extendedText: `How Domino’s decreased cost per acquisition by 65% with Twilio Segment`,
  extendedLink: `/customers/dominos/`,
}

export { testimonialData }
